import React from 'react';
import Migration from '../components/migration/migration';

export default function MigrationPage() {
    return (
        <>
            <Migration/>
        </>
    )
}